export { default } from './SortingProductsListHeader';
